import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";

import { config as CONFIG } from "app/app.config";

import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Subscription } from "rxjs";
import { InvitacionVisitaDTO } from "app/main/apps/shared/models/invitacion-visita.model";
import { VisitaService } from "app/main/apps/shared/services/rest/visita.service";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

const LARGOMAXIMO = 500;
@Component({
    selector: "app-dialog-invitar",
    templateUrl: "./dialog-invitar.component.html",
    styleUrls: ["./dialog-invitar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogInvitarComponent implements OnInit, OnDestroy {
    formInvitacion: FormGroup;
    config;
    subscripciones: Subscription;
    mostrarAvisoMontoOfertado: boolean;
    largoMaximo: number;
    constructor(
        public dialogRef: MatDialogRef<DialogInvitarComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            contratistas: ContratistaDTO[];
            idServicioSolicitudCotizacion: number;
        },
        private _fb: FormBuilder,
        private _visitaSrvc: VisitaService,
        private _notificacionesSrvc: NotificacionesService,
        private validadorFormSrvc: ValidadoresFormularioService
    ) {
        this.mostrarAvisoMontoOfertado = false;
        this.subscripciones = new Subscription();
        this.config = CONFIG;
        this.largoMaximo = LARGOMAXIMO;
    }

    ngOnInit(): void {
        //console.log(this.data);
        this.initForm();
    }

    initForm() {
        this.formInvitacion = this._fb.group({
            fechaVigencia: [null, { validators: [Validators.required] }],
            horaVigencia: [
                null,
                {
                    validators: [
                        Validators.required,
                        Validators.pattern(
                            this.validadorFormSrvc.regexFormatoHora
                        ),
                    ],
                },
            ],
            comentario: [
                "",
                {
                    validators: [Validators.maxLength(LARGOMAXIMO)],
                },
            ],
        });
    }

    get comentario() {
        return this.formInvitacion.get("comentario");
    }

    get fechaVigencia() {
        return this.formInvitacion.get("fechaVigencia");
    }

    get horaVigencia() {
        return this.formInvitacion.get("horaVigencia");
    }

    generarInvitacion() {
        //console.log(this.horaVigencia.value);
        const rutContratistas = this.data.contratistas.map(
            (contratista) => contratista.nrRut
        );
        const invitacion = new InvitacionVisitaDTO(
            rutContratistas,
            this.fechaVigencia.value.toISOString().split("T")[0] +
                "T" +
                this.horaVigencia.value +
                ":00",
            this.comentario.value
        );

        this.subscripciones.add(
            this._visitaSrvc
                .grabarInvitacionVisita(
                    this.data.idServicioSolicitudCotizacion,
                    invitacion
                )
                .subscribe((resp) => {
                    this._notificacionesSrvc.mostrarNotificacion(
                        "Invitación a cotizar enviada",
                        "success"
                    );
                    this.dialogRef.close();
                })
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
